import { SCUIContent } from '../../../atomic/organisms';
import { useTranslation } from 'react-i18next';
import { SCUIBreadCrumb } from '../../../atomic/molecules';
import React, { FC, useState, useEffect } from 'react';
import { Card, CardActions, CardHeader, CardContent, Divider, Grid, Typography } from '@mui/material';
import { SCUILoading, SCUITabs } from '../../../atomic/atoms';
import {
    SCUIRefundDetailCustomerInfo,
    SCUIRefundDetailPaymentInfo,
    SCUIRefundHistory,
    RefundPrepareSellerReturnShipment,
    RefundWaitingPayment,
} from './components';
import { useLocation } from 'react-router-dom';
import { RefundQuery, StoreQuery, ReturnQuery, PaymentQuery, CustomerQuery, CacheQuery } from '../../../services/query';
import TimeHelper from '../../../utils/time';
import { useHistory } from 'react-router-dom';
import Helper from '../../../utils/helper';
import { enumRefundStatusType } from '../../../types/enums/status';

export const Refund: FC<any> = (props: any) => {
    const query = new URLSearchParams(useLocation().search);
    const idfromUrl = query.get('id');
    const refundId = props.location.state?.id ? props.location.state?.id : idfromUrl;
    const { t } = useTranslation();
    const history = useHistory();
    const [getRefundInfo, setGetReturnInfo] = React.useState<any>();
    const [irsaliyeFaturaSeriNo, setIrsaliyeFaturaSeriNo] = React.useState<any>();
    const [isMpApprover, setIsMpApprover] = React.useState<any>();
    const [shippingListId, setShippingListId] = React.useState<any>();
    const [tabIndex, setTabIndex] = useState<any>(1);
    const [orderId, setOrderId] = useState<any>(0);
    const [paymentResult, setPaymentResult] = React.useState<any>();
    const [bankAccount, setBankAccount] = React.useState<any>();

    const [returnDatas, setReturnData] = React.useState<any>();
    const [pendingRefundAmount, setPendingRefundAmount] = useState<any>();
    const [waitingRefundVisible, setWaitingRefundVisible] = useState(false);
    const [symbol, setSymbol] = useState('');
    const [isMarketplacePayment, setIsMarketPlacePayment] = useState(false);
    const [documentHeaderOfInvoice, setDocumentHeaderOfInvoice] = useState<any>();
    const [tabList, setTabList] = useState([
        { id: 1, name: 'Müşteri Ödemeleri' },
        { id: 2, name: 'Yapılan Ödemeler' },
        { id: 3, name: 'Geri Ödeme Geçmişi' },
    ]);

    const _onChangeTabs = (_: any, activeTabIndex: any): void => {
        setTabIndex(activeTabIndex);
    };

    const GetRefund = () => {
        RefundQuery.GetRefund({ refundId: refundId }).then((res: any) => {
            if (res.data) {
                setGetReturnInfo(res.data.refundWrapper);
                const hasPendingRefunds = res.data.refundWrapper.distributeRefundResult.refundPlanList.map(
                    (plan: any) => plan.refundPlanStatus === 0
                );
                if (hasPendingRefunds.includes(true)) {
                    setTabList((tabList) => [...tabList, { id: 5, name: 'Bekleyen Geri Ödemeler' }]);
                    setWaitingRefundVisible(true);
                } else {
                    setWaitingRefundVisible(false);
                }

                if (res.data.refundWrapper.distributeRefundResult.distributedRefundDetails.length > 0) {
                    setPendingRefundAmount(
                        res.data.refundWrapper.distributeRefundResult.distributedRefundDetails.reduce(
                            (sum: any, item: any) => {
                                return sum + (item.distributedAmount - item.refundedAmount);
                            },
                            0
                        )
                    );
                }
            }
        });
    };
    const GetPaymentForReturn = async (): Promise<any> => {
        PaymentQuery.GetPaymentForReturn({
            orderId: orderId,
            returnId: getRefundInfo.refund.referenceId,
            status: getRefundInfo.refund.refundReason,
        }).then((res: any) => {
            if (res.data) {
                setPaymentResult(res.data);
            } else {
                setPaymentResult([]);
            }
        });
    };

    const GetDocumentHeaderOfInvoiceByOrderId = async (orderId: any) => {
        let params: any = {};
        params.orderId = orderId;
        StoreQuery.GetDocumentHeaderOfInvoiceByOrderId(params).then((res: any) => {
            if (res) setDocumentHeaderOfInvoice(res.data);
        });
    };

    const GetDocumentNo = async () => {
        let params: any = {};
        params.returnId = getRefundInfo.refund.referenceId;
        params.ShippingListId = shippingListId;

        RefundQuery.GetDocumentHeaderOfSellerReturnDispatchList(params).then((res: any) => {
            if (res.data.result) {
                setIrsaliyeFaturaSeriNo(res.data.result.formSerie + res.data.result.formOrderNo);
            }
        });
    };
    const GetBankAccount = async () => {
        let params: any = {};
        params.CustomerId = getRefundInfo.refund.customerId;
        params.BankAccountId = getRefundInfo.refundCustomerChoice && getRefundInfo.refundCustomerChoice.bankAccountId;

        CustomerQuery.GetBankAccount(params).then((res: any) => {
            if (res) setBankAccount(res.data);
        });
    };

    const GetReturnDetailByReturnId = () => {
        ReturnQuery.GetReturnDetailByReturnId({
            returnId: getRefundInfo.refund.referenceId,
            customerId: getRefundInfo.refund.customerId,
        }).then((res: any) => {
            if (res.data) {
                setReturnData(res.data);
                if (res.data.productDetailModels) {
                    setShippingListId(res.data.productDetailModels[0].shippingListId);
                }
                if (
                    res.data.isMarketPlaceReturn &&
                    (Helper.isStoreEmployeeForFrontend() || isMpApprover) &&
                    (getRefundInfo.refund.refundStatus === 2 || getRefundInfo.refund.refundStatus === 5)
                ) {
                    setTabList((tabList) => [...tabList, { id: 4, name: 'İade Sevk Hazırlama' }]); //tamamlandı statsünde ise gelecek
                }
                if (res.data.isMarketPlaceReturn) {
                    setIsMarketPlacePayment(true);
                }
            }
        });
    };

    useEffect(() => {
        if (orderId !== 0) {
            GetDocumentHeaderOfInvoiceByOrderId(orderId);
        }
    }, [orderId]);

    useEffect(() => {
        if (refundId) {
            GetRefund();
        }
    }, [refundId]);

    useEffect(() => {
        if (getRefundInfo) {
            GetReturnDetailByReturnId();
            setSymbol(getRefundInfo.refund.currencySymbol);
            setOrderId(getRefundInfo.orderId);
        }
    }, [getRefundInfo]);

    useEffect(() => {
        if (pendingRefundAmount > 0) {
            if (waitingRefundVisible) {
                GetBankAccount();
            }
        }
    }, [waitingRefundVisible]);

    useEffect(() => {
        if (shippingListId && Helper.isStoreEmployeeForFrontend() && isMarketplacePayment) {
            GetDocumentNo();
        }
    }, [shippingListId]);
    useEffect(() => {
        if (orderId !== 0) {
            GetPaymentForReturn();
        }
    }, [orderId]);

    useEffect(() => {
        CacheQuery.GetUSerClaims().then((res: any) => {
            setIsMpApprover(res.includes('backoffice_mpReturnApprover'));
        });
    }, []);

    return (
        <SCUIContent>
            {getRefundInfo ? (
                <Grid container direction="row" spacing={5}>
                    <Grid
                        size={{
                            sm: 12,
                            md: 2,
                            lg: 2,
                            xl: 2,
                        }}
                    >
                        {' '}
                        <p className="headtxt" style={{ marginTop: '1rem' }}>
                            {' '}
                            Geri Ödeme Detay
                        </p>
                    </Grid>
                    <Grid
                        size={{
                            sm: 12,
                            md: 10,
                            lg: 10,
                            xl: 10,
                        }}
                    >
                        {' '}
                        <SCUIBreadCrumb
                            components={[
                                { title: t('dashboard.returnRequests'), link: '/returnList' },
                                { title: 'Geri Ödeme', link: '/refund' },
                            ]}
                        />{' '}
                    </Grid>
                    <Grid
                        sx={{ paddingBottom: 1 }}
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <Typography>
                            {' '}
                            <strong>{refundId} ‘ No lu Geri Ödeme </strong>{' '}
                        </Typography>{' '}
                    </Grid>
                    <Grid
                        size={{
                            sm: 12,
                            md: 6,
                            lg: 4,
                            xl: 4,
                        }}
                    >
                        <Card style={{ height: '27rem' }}>
                            <CardHeader
                                title={
                                    <Typography noWrap gutterBottom variant="h6" component="h4">
                                        <b>{t('refund.paymentInfo')} </b>
                                    </Typography>
                                }
                            />
                            <Divider />
                            <CardContent>
                                {getRefundInfo && (
                                    <React.Fragment>
                                        <p>
                                            <b> {t('refundList.customerPaymentType')}:</b>
                                            {getRefundInfo.distributeRefundResult.refundPlanList[0] &&
                                                getRefundInfo.distributeRefundResult.refundPlanList[0]
                                                    .refundPlanMethodDescription}
                                        </p>
                                        <p>
                                            <b>{t('refundList.refundReasonDesc')}:</b>
                                            {getRefundInfo.refund.refundReasonName}
                                        </p>
                                        <p>
                                            <b> {t('return.returnId')}:</b>{' '}
                                            <label
                                                className="linktxt"
                                                onClick={() =>
                                                    history.push(
                                                        '/returnDetail/?ReturnId=' +
                                                            getRefundInfo.refund.referenceId +
                                                            '&customerId=' +
                                                            getRefundInfo.refund.customerId
                                                    )
                                                }
                                            >
                                                {getRefundInfo.refund.referenceId}
                                            </label>
                                        </p>
                                        <p>
                                            <b> Order Id:</b>{' '}
                                            <label
                                                className="linktxt"
                                                onClick={() =>
                                                    window.open(
                                                        Helper.getBackofficeUrl() +
                                                            'OrderDetail.aspx?OrderId=' +
                                                            getRefundInfo.orderId,
                                                        '_blank'
                                                    )
                                                }
                                            >
                                                {getRefundInfo.orderId}
                                            </label>
                                        </p>
                                        <p>
                                            <b> {t('refund.paymentStatus')}:</b> {getRefundInfo.refund.refundStatusName}
                                            {getRefundInfo.refund.refundStatus === 1 &&
                                                getRefundInfo.distributeRefundResult.refundPlanList.length > 0 &&
                                                getRefundInfo.distributeRefundResult.refundPlanList[0]
                                                    .refundPlanMethod === 1 && (
                                                    <label> - {t('general.eftRefundMessage')}</label>
                                                )}{' '}
                                        </p>
                                    </React.Fragment>
                                )}
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid
                        size={{
                            sm: 12,
                            md: 6,
                            lg: 4,
                            xl: 4,
                        }}
                    >
                        <Card style={{ height: '27rem' }}>
                            <CardHeader
                                title={
                                    <Typography noWrap gutterBottom variant="h6" component="h4">
                                        <b>Sipariş Bilgileri </b>
                                    </Typography>
                                }
                            />
                            <Divider />
                            <CardContent>
                                <p>
                                    <b>Tarih: </b>
                                    {TimeHelper.formatDateHour(getRefundInfo.refund.date)}
                                </p>
                                <p>
                                    <b>Refund ID: </b>
                                    {refundId}
                                </p>
                                <p>
                                    <b>{t('general.orderNo')}</b>
                                    {getRefundInfo.orderNumber}
                                </p>
                                {documentHeaderOfInvoice && (
                                    <p>
                                        <b>{t('general.shippingNo')}: </b>
                                        {documentHeaderOfInvoice.shippingListNo}{' '}
                                    </p>
                                )}
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid
                        size={{
                            sm: 12,
                            md: 6,
                            lg: 4,
                            xl: 4,
                        }}
                    >
                        <Card style={{ height: '27rem' }}>
                            <CardHeader
                                title={
                                    <Typography noWrap gutterBottom variant="h6" component="h4">
                                        <b>Müşteri Bilgileri </b>
                                    </Typography>
                                }
                            />
                            <Divider />
                            <CardContent>
                                <p>
                                    <b> Müşteri Id:</b>{' '}
                                    <label
                                        className="linktxt"
                                        onClick={() =>
                                            history.push(
                                                '/customerManagement?ActiveTab=OrderInformation&customerId=' +
                                                    getRefundInfo.refund.customerId
                                            )
                                        }
                                    >
                                        {getRefundInfo.refund.customerId}
                                    </label>
                                </p>
                                {documentHeaderOfInvoice && (
                                    <p>
                                        <b>Müşteri: </b>
                                        {documentHeaderOfInvoice.customerFirstName}{' '}
                                        {documentHeaderOfInvoice.customerLastName}
                                    </p>
                                )}
                                <br />
                                <br />
                            </CardContent>
                            <CardActions>
                                <br />
                            </CardActions>
                        </Card>
                    </Grid>
                    <Grid
                        sx={{ marginTop: 3 }}
                        size={{
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <SCUITabs
                            tabList={Object.values(tabList)}
                            onChange={_onChangeTabs}
                            activeTabIndex={tabIndex}
                        ></SCUITabs>
                    </Grid>
                    <br />
                    {tabIndex === 1 && paymentResult && (
                        <Grid
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <SCUIRefundDetailCustomerInfo paymentResult={paymentResult} currencySymbol={symbol} />
                        </Grid>
                    )}
                    {tabIndex === 2 && getRefundInfo && (
                        <Grid
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            {' '}
                            <SCUIRefundDetailPaymentInfo getRefundInfo={getRefundInfo} currencySymbol={symbol} />
                        </Grid>
                    )}
                    {tabIndex === 3 && (
                        <Grid
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            {' '}
                            <SCUIRefundHistory refundId={refundId} />{' '}
                        </Grid>
                    )}
                    {tabIndex === 4 && (
                        <Grid
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            {' '}
                            <RefundPrepareSellerReturnShipment
                                shippingListId={shippingListId}
                                orderId={orderId}
                                customerId={getRefundInfo.refund.customerId}
                                irsaliyeFaturaSeriNo={irsaliyeFaturaSeriNo}
                                returnId={getRefundInfo.refund.referenceId}
                            />
                        </Grid>
                    )}
                    {tabIndex === 5 && waitingRefundVisible && (
                        <Grid
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <RefundWaitingPayment
                                currencySymbol={symbol}
                                customerFirstName={documentHeaderOfInvoice && documentHeaderOfInvoice.customerFirstName}
                                customerLastName={documentHeaderOfInvoice && documentHeaderOfInvoice.customerLastName}
                                orderId={orderId}
                                returnId={getRefundInfo.refund.referenceId}
                                returnDatas={returnDatas}
                                distributedRefundDetails={getRefundInfo.distributeRefundResult.distributedRefundDetails}
                                refundPlanList={getRefundInfo.distributeRefundResult.refundPlanList}
                                bankAccoutData={bankAccount}
                                customerId={getRefundInfo.refund.customerId}
                                refundId={refundId}
                                refundStatus={enumRefundStatusType[getRefundInfo.refund.refundStatus]}
                            />
                        </Grid>
                    )}
                </Grid>
            ) : (
                <SCUILoading />
            )}
        </SCUIContent>
    );
};
